"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const task_entity_1 = require("./task.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let TaskDocumentMap = class TaskDocumentMap {
    constructor(taskId, documentId) {
        this.taskId = taskId;
        this.documentId = documentId;
    }
};
exports.TaskDocumentMap = TaskDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], TaskDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "task_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], TaskDocumentMap.prototype, "taskId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], TaskDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => task_entity_1.Task, (task) => task.taskDocs, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "task_id" }),
    tslib_1.__metadata("design:type", Object)
], TaskDocumentMap.prototype, "task", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (fileupload) => fileupload.taskDocs, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Object)
], TaskDocumentMap.prototype, "document", void 0);
exports.TaskDocumentMap = TaskDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("task_document_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number])
], TaskDocumentMap);
